/* 三國逗陣打 · 社交連線（v0.1.2）：會員在選單畫面保持一條連線，收好友狀態、組隊邀請；
 * 隊長開始排位或開房時，伺服器送 s:go，這裡幫隊員自動跟上。畫面在 home.ts（大廳側欄的隊伍、好友卡）。 */
// @ts-nocheck — 和 net.ts 一樣，型別之後再補
import { SG } from '../core/sg.ts';

const listeners = [], dmListeners = [];
const Social = {
  state: null, // 伺服器推來的 s:state：me、friends、incoming、outgoing、party、invites
  ws: null,
  on(fn) { listeners.push(fn); },
  onDm(fn) { dmListeners.push(fn); }, // 私訊（v0.4.0）：s:dm、s:dmhist、s:players 與帶流水號的錯誤，畫面在 src/game/dm.ts
  send(m) { if (this.ws && this.ws.readyState === 1) this.ws.send(JSON.stringify(m)); },
  party() { const p = this.state && this.state.party; return p && p.members.length > 1 ? p : null; },
  isLeader() { const p = this.party(); return !!p && p.leader === this.state.me.id; },
  ensure,
};
SG.Social = Social;
const emit = () => { for (const fn of listeners) try { fn(Social.state); } catch (e) { console.error(e); } };
const esc = (t) => String(t == null ? '' : t).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);
const toast = (t) => { if (SG.Home && SG.Home.toast) SG.Home.toast(t); };

// 有登入才連；登出了就關掉（每 15 秒、切回分頁時檢查一次）
let checking = false, stopped = false;
async function ensure() {
  if (checking || stopped) return;
  checking = true;
  try {
    const j = await fetch('api/me', { cache: 'no-store' }).then((r) => (r.ok ? r.json() : null));
    const user = j && j.user;
    if (user && !Social.ws) open();
    else if (!user && Social.ws) Social.ws.close();
  } catch (e) { /* 沒有伺服器（靜態頁）：不顯示好友 */ } finally { checking = false; }
}
function open() {
  const ws = new WebSocket((location.protocol === 'https:' ? 'wss://' : 'ws://') + location.host + '/ws');
  Social.ws = ws;
  ws.onopen = () => ws.send(JSON.stringify({ t: 'hello', social: true }));
  ws.onmessage = (e) => { let m; try { m = JSON.parse(e.data); } catch (x) { return; } onMessage(m); };
  ws.onclose = () => { if (Social.ws === ws) { Social.ws = null; Social.state = null; emit(); } if (!stopped) setTimeout(ensure, 3000); };
}
function onMessage(m) {
  if (m.t === 's:state') { Social.state = m; emit(); for (const iv of m.invites) showInvite(iv); return; }
  if (m.t === 's:invite') { showInvite(m); return; }
  if (m.t === 's:go') { go(m); return; }
  if (m.t === 's:note') { toast(m.text); if (m.kicked) stopped = true; return; }
  if (m.t === 's:dm' || m.t === 's:dmhist' || m.t === 's:players' || (m.t === 'err' && m.c != null)) { if (dmListeners.length) { for (const fn of dmListeners) try { fn(m); } catch (e) { console.error(e); } return; } }
  if (m.t === 'err') toast(m.text);
}
// 隊長開始了：排位就一起進佇列；一般房就進隊長的房間
function go(m) {
  if (SG.Home && SG.Home.show) SG.Home.show('hall');
  const N = SG.NET; if (!N || !N.connect) return;
  if (m.queue === 'ranked') N.connect({ queue: 'ranked', mode: 'ranked', mm: true, party: true });
  else if (m.room) N.connect({ room: m.room, queue: 'normal' });
}
// 組隊邀請：右下角的卡片，60 秒後自動消失
const shown = new Set();
function showInvite(iv) {
  if (shown.has(iv.party)) return;
  shown.add(iv.party);
  let box = document.getElementById('s-invites');
  if (!box) { box = document.createElement('div'); box.id = 's-invites'; box.className = 's-invites'; box.setAttribute('aria-live', 'polite'); document.body.appendChild(box); }
  const el = document.createElement('div'); el.className = 's-invite';
  el.innerHTML = `<p><b>${esc(iv.nick)}</b> 邀請你組隊</p><div><button class="btn" type="button" data-a="no">拒絕</button><button class="btn primary" type="button" data-a="yes">加入</button></div>`;
  const done = () => { el.remove(); shown.delete(iv.party); };
  el.onclick = (e) => {
    const a = e.target.closest('[data-a]'); if (!a) return;
    Social.send(a.dataset.a === 'yes' ? { t: 's:join', party: iv.party } : { t: 's:nojoin', party: iv.party });
    done();
  };
  box.appendChild(el);
  setTimeout(done, 60000);
}

setInterval(ensure, 15000);
window.addEventListener('focus', ensure);
document.addEventListener('visibilitychange', () => { if (!document.hidden) ensure(); }); // 手機從背景回來
ensure();
